import basicHandling from './basicHandling.js';
import closeAirSupport from './closeAirSupport.js';
import airToAir from './airToAir.js';

/**
 * Registry of guided training missions, keyed by the `training` field a scenario
 * carries in SimConfig.SCENARIOS. App looks the definition up here when it
 * builds a scenario and, if it finds one, spins up a TrainingMission for it.
 */
export const TRAINING_MISSIONS = {
  basicHandling,
  closeAirSupport,
  airToAir,
};

/** Definition for a scenario's `training` key, or null when it isn't a training run. */
export function getTrainingMission(key) {
  return (key && TRAINING_MISSIONS[key]) || null;
}
